import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IUserRequestData } from '../../components/widgets/public/activityCalendar/models'

import { initialState } from './config'
import { IMandatoryFields } from './models/IMandatoryFields'
import { IUserSettings } from './models/IUserSettings'
import { TCalendarDropdowns } from './models/TCalendarDropdowns'

const calendarSlice = createSlice({
  name: 'activityCalendar',
  initialState,
  reducers: {
    setUserSettings: (state, action: PayloadAction<IUserSettings>) => {
      state.userSettings = action.payload
    },
    setUserRequestData: (state, action: PayloadAction<IUserRequestData>) => {
      state.userRequestData = action.payload
    },
    setCalendarDropdowns: (state, action: PayloadAction<TCalendarDropdowns>) => {
      state.rfbDropdowns = action.payload
    },
    setMandatoryFields: (state, action: PayloadAction<IMandatoryFields>) => {
      state.mandatoryFields = action.payload
    },
  },
})

export const { setUserSettings, setUserRequestData, setCalendarDropdowns, setMandatoryFields } =
  calendarSlice.actions

export const calendarReducer = calendarSlice.reducer
